var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eSNkzOmXcng1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 42 42",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: 42,
    height: 42,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#ff5151",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.535885 0 0 0.535885 1.004791 0.000007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.817903,30.7273L43.0907,22h-14.5454c-1.6023,0-2.9091,1.3068-2.9091,2.9091v26.1818C25.6362,52.6932,26.943,54,28.5453,54h20.3636c1.6022,0,2.909-1.3068,2.909-2.9091l.000003-20.3636Z",
    fill: "none",
    stroke: "#ff5151",
    strokeWidth: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0903,22v8.7273h8.7273",
    fill: "none",
    stroke: "#ff5151",
    strokeWidth: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3638,39.4546h8.7272",
    fill: "none",
    stroke: "#ff5151",
    strokeWidth: 2.46,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3638,45.2727h5.8181",
    fill: "none",
    stroke: "#ff5151",
    strokeWidth: 2.46,
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredIcon);
export default __webpack_public_path__ + "static/media/expired-icon.47ade185f4bff43bbe95a6a312d65a91.svg";
export { ForwardRef as ReactComponent };